<template>
  <div
    v-show="isOpen"
    v-body-scroll-lock="isOpen && !noBackground"
    class="modal-view"
    :class="classes"
    @pointerdown="onPointerDown"
    @click.self="onBackdropClick"
  >
    <slot />
  </div>
</template>

<script>
export default {
  provide: {
    popoversZLayer: 'modals',
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    noBackground: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['backdropClicked'],
  data: () => ({
    // where the last press started: only one that started on the
    // backdrop closes (a text selection dragged out of a form ends there)
    pressedBackdrop: false,
  }),
  methods: {
    onPointerDown(e) {
      this.pressedBackdrop = e.target === e.currentTarget
    },
    onBackdropClick() {
      if (this.pressedBackdrop) this.$emit('backdropClicked')
    },
  },
  computed: {
    classes() {
      return {
        'modal-background': !this.noBackground,
        open: this.isOpen,
      }
    },
  },
}
</script>

<style lang="scss">
.modal-view {
  z-index: var(--ZI_modals);
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  pointer-events: none;
  animation-duration: 0.2s;
  animation-name: modal-background-fadein;
  opacity: 0;

  > * {
    pointer-events: initial;
  }

  &.modal-background {
    pointer-events: initial;
    background-color: var(--backdrop);
  }

  &.open {
    opacity: 1;
  }
}

@keyframes modal-background-fadein {
  from {
    background-color: transparent;
  }

  to {
    background-color: var(--backdrop);
  }
}
</style>
